<template>
  <div class="mark-lp-base">
    <div class="lp-block1 lp-block">
      <img class="main-title" src="/static/img/mark_lp/kurenotori/title.png" alt="" v-intersection>
      <div class="img-wrap" v-intersection>
        <img class="base" src="/static/img/mark_lp/kurenotori/img_02a_b.png" alt="">
        <img class="upper1" src="/static/img/mark_lp/kurenotori/img_02b.png" alt="">
        <img class="upper2" src="/static/img/mark_lp/kurenotori/img_02c.png" alt="">
        <img class="upper3" src="/static/img/mark_lp/kurenotori/img_02d_b.png" alt="">
        <img class="upper4" src="/static/img/mark_lp/kurenotori/img_02e.png" alt="">
        <img class="upper5" src="/static/img/mark_lp/kurenotori/img_02f.png" alt="">
        <div class="target-elm1 tgt-btn" @click.prevent="onLinkClick('utv-userinput')">今すぐ占う</div>
      </div>
      <p class="normal-text">占いTV 月額528円(税込)</p>
      <a class="link-pink" href="" @click.prevent="onLinkClick('utv-login')"><p class="link-pink-text">占いTV月額会員ログインはこちら</p></a>
      <img class="kire" src="/static/img/mark_lp/kurenotori/lp_kireme_01.png" alt="">
    </div>
    <div class="lp-block2 lp-block">
      <div class='img-wrap img-wrap-1' v-intersection>
        <img class="base" src="/static/img/mark_lp/kurenotori/img_03a.png" alt="">
        <img class="fuki" src="/static/img/mark_lp/kurenotori/img_03b.png" alt="">
      </div>
      <div class='img-wrap img-wrap-2'>
        <img class="banner base" src="/static/img/mark_lp/kurenotori/banner01.png" alt="" :class="{show: bannerChangeNum === 1}">
        <img class="banner upper1" src="/static/img/mark_lp/kurenotori/banner02.png" alt="" :class="{show: bannerChangeNum === 2}">
      </div>
      <p class="caption">※メニュー名:鳳凰数術で占う！あなたの鳳凰タイプは？より</p>
      <img src="/static/img/mark_lp/kurenotori/img_04.png" alt="">
      <div class="target-elm2 tgt-btn" v-intersection @click.prevent="onLinkClick('utv-basicinput')">無料占いをする</div>
      <img class="kire" src="/static/img/mark_lp/kurenotori/lp_kireme_02.png" alt="">
    </div>
    <div class="lp-block3 lp-block">
      <img src="/static/img/mark_lp/kurenotori/img_05.png" alt="">
      <div class="img-wrap img-wrap-2">
        <img class="banner base" src="/static/img/mark_lp/kurenotori/banner03.png" alt="" :class="{show: bannerChangeNum === 1}">
        <img class="banner upper1" src="/static/img/mark_lp/kurenotori/banner04.png" alt="" :class="{show: bannerChangeNum === 2}">
      </div>
      <p class="caption">※メニュー名:生まれた瞬間に刻まれたあなたの「宿命」より</p>
      <div class="img-wrap img-wrap-1" v-intersection>
        <img class="base" src="/static/img/mark_lp/kurenotori/img_06a.png" alt="">
        <img class="upper1" src="/static/img/mark_lp/kurenotori/img_06b.png" alt="">
        <div class="target-elm3 tgt-btn" @click.prevent="onLinkClick('utv-userinput')">今すぐ占う</div>
      </div>
      <p class="caption-price">占いTV　月額528円(税込)<br>※一部個別料金あり</p>
      <img src="/static/img/mark_lp/kurenotori/img_text.png" alt="">
      <img class="kire" src="/static/img/mark_lp/kurenotori/lp_kireme_03.png" alt="">
    </div>
    <div class="lp-block4 lp-block">
      <img class="img_07a" src="/static/img/mark_lp/kurenotori/img_07a.png" alt="">
      <img class="img_07b" src="/static/img/mark_lp/kurenotori/img_07b.png" alt="">
      <img class="img_07c" src="/static/img/mark_lp/kurenotori/img_07c.png" alt="">
      <div class="img-wrap" v-intersection>
        <img class="base" src="/static/img/mark_lp/kurenotori/img_07d.png" alt="">
        <img class="upper1" src="/static/img/mark_lp/kurenotori/img_07e.png" alt="">
        <img class="upper2"src="/static/img/mark_lp/kurenotori/img_07f.png" alt="">
        <img class="upper3" src="/static/img/mark_lp/kurenotori/img_07g.png" alt="">
        <p class="caption-price">※抽選権の付与は占いTVの月額会員登録及びINE登録をされた方となります</p>
      </div>
      <div class="target-elm4 tgt-btn" v-intersection @click.prevent="onLinkClick('utv-userinput')">今すぐ登録</div>
      <p class="caption-price">占いTV　月額528円(税込)<br>※一部個別料金あり</p>
      <img class="kire" src="/static/img/mark_lp/kurenotori/lp_kireme_04.png" alt="">

    </div>
    <div class="lp-block5 lp-block">
      <img class="img_08a" src="/static/img/mark_lp/kurenotori/img_08a.png" alt="">
      <img class="img_08b" src="/static/img/mark_lp/kurenotori/img_08b.png" alt="">
      <div class="img-wrap img-wrap-1">
        <img class="base" src="/static/img/mark_lp/kurenotori/img_08c_1.png" alt="">
        <img class="upper1" src="/static/img/mark_lp/kurenotori/img_08c_2.png" alt="" v-intersection>
      </div>
      <div class="img-wrap img-wrap-2" v-intersection>
        <img class="base" src="/static/img/mark_lp/kurenotori/img_08d_1.png" alt="">
        <img class="upper1" src="/static/img/mark_lp/kurenotori/img_08d_2.png" alt="">
        <img class="upper2"src="/static/img/mark_lp/kurenotori/img_08d_3.png" alt="">
        <img class="upper3" src="/static/img/mark_lp/kurenotori/img_08d_4.png" alt="">
        <div class="target-elm5 tgt-btn" @click.prevent="onLinkClick('utv-userinput')">占いTVに入会する</div>
      </div>
      <img src="/static/img/mark_lp/kurenotori/img_09.png" alt="">
      <div class="img-wrap img-wrap-3" v-intersection>
        <div class="target-elm6 tgt-btn" @click.prevent="onLinkClick('utv-userinput')">占いTVに入会する</div>
        <div class="target-elm-purple tgt-btn" @click.prevent="onLinkClick('utv-yearluck')">
          <p class="purple-mintext">2022年下半期運勢を</p>
          <p class="purple-maintext">購入する</p>
        </div>
      </div>
      <p class="caption-price">占いTV　月額528円(税込)<br>※一部個別料金あり</p>
      <img class="kire" src="/static/img/mark_lp/kurenotori/lp_kireme_01.png" alt="">
    </div>

    <div class="lp-block6 lp-block">
      <img src="/static/img/mark_lp/kurenotori/img_10.png" alt="">
      <div class="target-elm7 tgt-btn" v-intersection @click.prevent="onLinkClick('utv-userinput')">今すぐ占う</div>
    </div>
    <lp-block7 />
    <lp-footer :color-scheme="colorScheme" :menu-list="footerMenuList" />
  </div>
</template>

<script>
import LpBlock7 from '@/utvStore/components/MarkLp/Kurenotori/Lp1/LpBlock7'
import LpFooter from '@/utvStore/components/recommend/lp/blocks/LpFooter'
import * as type from '@/utvStore/store/mutation-types'
import { BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import { COLOR_SCHEME } from './basicInfos'

export default {
  name: 'KurenotoriLp1',
  components: {
    LpBlock7,
    LpFooter
  },
  data(){
    return {
      bannerChangeNum: 1,
    }
  },
  computed: {
    colorScheme() {
      return COLOR_SCHEME
    },
    footerMenuList() {
      return [...DEFAULT_FOOTER_MENULIST]
    }
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.colorScheme)
  },
  mounted() {
    setInterval(()=>{
      let num = this.bannerChangeNum + 1
      this.bannerChangeNum = num > 2 ? 1 : num
    }, 1500)
  },
  methods: {
    onLinkClick(target){
      let tgtUrl = ''
      switch (target){
        case 'utv-userinput':
          location.href = '/user/input'
          break
        case 'utv-login':
          location.href = '/user/login'
          break
        case 'utv-basicinput':
          location.href = '/recommend/lp/1/basic/input'
          break
        case 'utv-yearluck':
          location.href = '/2022_luck'
          break
      }
    }
  }
}</script>

<style scoped lang="scss">
$pink: #ff6f93;
$lightpink: #ffe2eb;
$lightblue: #d7fbff;
$purple: #796deb;

// FOT-筑紫A丸ゴシック Std R
.tsuku-maru {
  font-family: fot-tsukuardgothic-std, sans-serif;
  font-weight: 400;
  font-style: normal;
}

// FOT-筑紫A丸ゴシック Std B
.tsuku-maru-b {
  font-family: fot-tsukuardgothic-std, sans-serif;
  font-weight: 700;
  font-style: normal;
}

.img-wrap {
  width: 100%;
  position: relative;
  .upper1,
  .upper2,
  .upper3,
  .upper4,
  .upper5 {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.lp-block1 {
  .main-title {
    transition: all 300ms ease-out 0s;
    opacity: 0;
    &.intersecting {
      opacity: 1;
    }
  }
  .img-wrap {
    .base {
      transition: all 500ms ease-out 100ms;
      transform: translate(-20px, 0);
      opacity: 0;
    }
    .upper1 {
      transition: all 550ms ease-out 150ms;
      transform: translate(20px, 0);
      opacity: 0;
    }
    .upper2 {
      transition: all 1100ms ease-out 400ms;
      opacity: 0;
    }
    .upper3 {
      transition: all 500ms ease-out 1800ms;
      transform: translate(0, -20px);
      opacity: 0;
    }
    .upper4 {
      transition: all 700ms ease-out 500ms;
      transform: translate(0, 10px);
      opacity: 0;
    }
    .upper5 {
      transition: all 700ms ease-out 700ms;
      transform: translate(0, 10px);
      opacity: 0;
    }
    .target-elm1 {
      transition: all 1000ms ease-out 1200ms;
      transform: translate(0, 20px);
      opacity: 0;
    }
    &.intersecting {
      .base {
        transform: translate(0, 0);
        opacity: 1;
      }
      .upper1 {
        transform: translate(0, 0);
        opacity: 1;
      }
      .upper2 {
        opacity: 1;
      }
      .upper3 {
        transform: translate(0, 0);
        opacity: 1;
      }
      .upper4 {
        transform: translate(0, 0);
        opacity: 1;
      }
      .upper5 {
        transform: translate(0, 0);
        opacity: 1;
      }
      .target-elm1 {
        transform: translate(0, 0);
        opacity: 1;
      }
    }
  }
}

.lp-block2 {
  .img-wrap-1 {
    .base {
      display: block;
      transform: translate(0, 10px);
      opacity: 0;
      transition: all 500ms ease-out 0s;
    }
    .fuki {
      display: block;
      position: absolute;
      width: 100%;
      top: 31%;
      transition: all 800ms cubic-bezier(.26,.68,.5,1.18) 300ms;
      opacity: 0;
      transform: scale(0.95) translate(0, 10px);
      transform-origin: bottom center;
    }
    &.intersecting {
      .base {
        transform: translate(0, 0);
        opacity: 1;
      }
      .fuki {
        opacity: 1;
        transform: scale(1) translate(0, 0);
      }
    }
  }
  .target-elm2 {
    transition: all 1000ms ease-out 0s;
    opacity: 0;
    transform: translate(0, 20px);
    &.intersecting {
      opacity: 1;
      transform: translate(0, 0);
    }
  }
  .img-wrap-2 {
    .upper1,
    .upper2,
    .upper3 {
      left: 0;
      right: 0;
    }
    .banner {
      opacity: 0;
      transition: opacity 100ms ease-out 0s;
      &.show {
        opacity: 1;
      }
    }
  }
}

.lp-block3 {
  .img-wrap-1 {
    .upper1 {
      transition: all 500ms ease-out 0s;
      transform: translate(10px, 0);
      opacity: 0;
    }
    .target-elm3 {
      transition: all 1000ms ease-out 200ms;
      transform: translate(0, 20px);
      opacity: 0;
    }
    &.intersecting {
      .upper1 {
        opacity: 1;
        transform: translate(0, 0);
      }
      .target-elm3 {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }
  .img-wrap-2 {
    .upper1,
    .upper2,
    .upper3 {
      left: 0;
      right: 0;
    }
    .banner {
      opacity: 0;
      transition: opacity 100ms ease-out 0s;
      &.show {
        opacity: 1;
      }
    }
  }
}

.lp-block4 {
  .img-wrap {
    .upper1 {
      transition: all 500ms ease-out 0s;
      transform: translate(10px, 0);
      opacity: 0;
    }
    .upper2 {
      transition: all 500ms ease-out 100ms;
      transform: translate(10px, 0);
      opacity: 0;
    }
    .upper3 {
      transition: all 500ms ease-out 200ms;
      transform: translate(10px, 0);
      opacity: 0;
    }
    &.intersecting {
      .upper1 {
        opacity: 1;
        transform: translate(0, 0);
      }
      .upper2 {
        opacity: 1;
        transform: translate(0, 0);
      }
      .upper3 {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
    .caption-price {
      margin-top: -20px;
    }
  }
  .target-elm4 {
    transition: all 1000ms ease-out 100ms;
    transform: translate(0, 20px);
    opacity: 0;
    &.intersecting {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
}

.lp-block5 {
  .img-wrap-1 {
    .upper1 {
      transition: all 1800ms cubic-bezier(.09,.69,.02,1.46) 0s;
      opacity: 0;
      transform: scale(0.95);
      &.intersecting {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
  .img-wrap-2 {
    .base {
      transition: all 500ms ease-out 200ms;
      opacity: 0;
    }
    .upper1 {
      transition: all 700ms cubic-bezier(.09,.69,.02,1.46) 600ms;
      transform-origin: left center;
      transform: translate(10px, 0) scale(0.95);
      opacity: 0;
    }
    .upper2 {
      transition: all 400ms ease-out 900ms;
      transform-origin: right center;
      transform: scale(1.3) translate(20px, 0);
      opacity: 0;
    }
    .upper3 {
      transition: all 300ms ease-out 700ms;
      transform: translate(0, 10px);
      opacity: 0;
    }
    .target-elm5 {
      transition: all 1000ms ease-out 1000ms;
      opacity: 0;
      transform: translate(0, 20px);
    }
    &.intersecting {
      .base {
        opacity: 1;
      }
      .upper1 {
        opacity: 1;
        transform: translate(0, 0) scale(1);
      }
      .upper2 {
        opacity: 1;
        transform: scale(1) translate(0, 0);
      }
      .upper3 {
        opacity: 1;
        transform: translate(0, 0);
      }
      .target-elm5 {
        opacity: 1;
        transform: translate(0, 0);
      }
    }
  }
  .img-wrap-3 {
    .target-elm6 {
      transition: all 1000ms ease-out 0s;
      transform: translate(0, 20px);
      opacity: 0;
    }
    .target-elm-purple {
      transition: all 1000ms ease-out 200ms;
      transform: translate(0, 20px);
      opacity: 0;
    }
    &.intersecting {
      .target-elm6 {
        transform: translate(0, 0);
        opacity: 1;
      }
      .target-elm-purple {
        transform: translate(0, 0);
        opacity: 1;
      }
    }
  }
}

.lp-block6 {
  .target-elm7 {
    transition: all 1000ms ease-out 0s;
    transform: translate(0, 20px);
    opacity: 0;
    &.intersecting {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
}



/deep/ {
  .tgt-btn {
    @extend .tsuku-maru-b;
    display: inline-block;
    padding: 7px 0;
    border: 1px solid $pink;
    border-radius: 50px;
    background: $pink;
    //transition: all 500ms ease-out 500ms;
    //opacity: 0;
    //transform: translate(0, 40px);
    //font-weight: bold;
    font-size: 21px;
    color: #fff;
    width: 80%;
    margin-bottom: 16px;
    user-select: none;
    cursor: pointer;
    -webkit-text-stroke: 0.6px white;

    /*
    &.target-elm4 {
      transform: translate(100px, 0);
    }
     */

    &.target-elm-purple {
      border: 1px solid $purple;
      background: $purple;
      .purple-mintext {
        -webkit-text-stroke: initial;
      }
    }

    /*
    &.intersecting {
      opacity: 1;
      transform: translate(0, 0);
    }
     */
  }

  .purple-maintext {
    margin: 0;
  }

  .purple-mintext {
    font-size: 14px;
    margin: 0;
    line-height: 1;
    padding-top: 4px;
  }

  .up {
    transition: all 500ms ease-out 500ms;
    transform: translate(0, 40px);
    opacity: 0;

    &.intersecting {
      opacity: 1;
      transform: translate(0, 0);
    }
  }

  .normal-text {
    margin: 0;
    color: #000;
    font-size: 11px;
  }

  .link-pink {
    text-decoration: underline;
    color: $pink;
  }

  .link-pink-text {
    margin: 0;
    color: $pink;
    font-size: 11px;
    letter-spacing: 0.7px;
  }


  .caption {
    width: 80%;
    font-size: 10px;
    margin: auto;
    margin-bottom: 12px;
    color: #000;
  }

  .caption-price {
    width: 80%;
    font-size: 10px;
    margin: auto;
    margin-top: -6px;
    color: #000;
    margin-bottom: 24px;
  }


  .lp-block {
    width: 100%;
    // height: 100vh;
    text-align: center;
    padding: 0;
    padding-top: 24px;

    img {
      width: 100%;
      display: inherit;
      &.banner {
        width: 80%;
        height: auto;
        margin: auto;
      }

    }

    &.lp-block1 {
      background: #fff;
      background-image: url(/static/img/mark_lp/kurenotori/img_01.png);
      background-repeat: no-repeat;
      background-position-y: -30px;
      background-size: contain;
    }

    &.lp-block2 {
      background: $lightpink;
    }

    &.lp-block3 {
      background: #fff;
      padding-top: 0;
    }

    &.lp-block4 {
      background: $lightblue;
      padding-top: 0;
    }

    &.lp-block5 {
      background: #fff;
      padding-top: 0;
    }

    &.lp-block6 {
      background: $lightpink;
      padding-bottom: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/MarkLp/Kurenotori/Lp1/KurenotoriLp1.vue